import { createRouter, createWebHistory } from 'vue-router';
import { appEntries, toRoutes } from './registry';
import { auth0 } from './auth/auth0';
import { createAppGuard } from './auth/guard';
import { readStoredTenantId } from './session/session';
import HomeView from './views/HomeView.vue';
import LoginView from './views/LoginView.vue';
import NotFoundView from './views/NotFoundView.vue';

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            // Requires auth like any app route, and for the same reason: the index
            // lists what the *confirmed tenant* may use, so without one it can only
            // render an empty page. It was public while the index showed every app
            // to everyone; once that list became tenant-derived, a signed-out
            // visitor landed on a dead end instead of the picker.
            //
            // The Auth0 callback is unaffected — the guard passes `?code&state`
            // through before it looks at this.
            path: '/',
            name: 'home',
            component: HomeView,
            meta: { title: 'UAT Apps', requiresAuth: true },
        },
        {
            path: '/login',
            name: 'login',
            component: LoginView,
            meta: { title: 'Sign in', requiresAuth: false },
        },
        ...toRoutes(appEntries),
        {
            path: '/:pathMatch(.*)*',
            name: 'not-found',
            component: NotFoundView,
            meta: { title: 'Not found', requiresAuth: false },
        },
    ],
});

router.beforeEach(
    createAppGuard({
        auth: { isLoading: auth0.isLoading, isAuthenticated: auth0.isAuthenticated },
        readTenantId: readStoredTenantId,
    }),
);

router.afterEach((to) => {
    const title = to.meta.title as string | undefined;
    document.title = title ? `${title} — PerformX UAT Apps` : 'PerformX UAT Apps';
});
